export default function mockActivation(status) {
  if (status === 'inactive') {
    return;
  }
  return {
    activation: {
      mid: 10293
    }
  };
}
